$(document).ready(function(){
  !(function () {
        for (
          var t = document.querySelectorAll(".youtube"), e = 0;
          e < t.length;
          e++
        )
          t[e].addEventListener("click", function () {
            var t = document.createElement("iframe");
            t.setAttribute("frameborder", "0"),
              t.setAttribute(
                "allow",
                "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              ),
              t.setAttribute("allowfullscreen", ""),
              t.setAttribute("width", this.dataset.width),
              t.setAttribute("height", this.dataset.height),
              t.setAttribute(
                "src",
                "https://www.youtube.com/embed/" +
                  this.dataset.embed +
                  "?rel=0&showinfo=0&autoplay=1"
              ),
              (this.innerHTML = ""),
              this.appendChild(t);
          });
      })();
});